import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { useAuth } from '../modules/auth/AuthContext';
import PrivateRoutes from './PrivateRoutes';
import LoginPage from '../pages/LoginPage';
import IntroPage from '../pages/IntroPage';
import ResetPage from '../pages/ResetPage';
import ForgotPage from '../pages/ForgotPage';

const AppRouter: React.FC = () => {
  const { currentUser } = useAuth();

  return (
    <Router>
      <Routes>
        {currentUser ? (
          <Route path="/*" element={<PrivateRoutes />} />
        ) : (
          <>
            <Route path="intro" element={<IntroPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="reset-password" element={<ResetPage />} />
            <Route path="forgot-password" element={<ForgotPage />} />
            <Route path="*" element={<Navigate to="/intro" />} />
          </>
        )}
      </Routes>
    </Router>
  );
};

export default AppRouter;
